export const faqData = [
  {
    question: "柠檬导航收录网站的标准是什么？",
    answer: "我们坚持\"精选优质、宁缺毋滥\"的原则。收录的网站需满足以下标准：界面设计美观、内容质量高、用户体验好、无恶意广告和弹窗、服务稳定可靠。每个收录网站都经过人工审核，确保为用户提供真正有价值的网址资源。",
  },
  {
    question: "如何向柠檬导航推荐或申请收录网站？",
    answer: "您可以通过\"关于我们\"页面的联系表单提交网站推荐申请。请提供网站的完整信息，包括网站名称、网址、简介和所属分类。我们的编辑团队会在3个工作日内完成审核，审核通过后会邮件通知您。",
  },
  {
    question: "柠檬导航是否收费？",
    answer: "柠檬导航对所有用户完全免费开放使用。我们不向用户收取任何费用，也没有付费会员制度。我们的宗旨是为大家提供一个纯净、优质的网址导航服务，让每个人都能方便地找到需要的网站。",
  },
  {
    question: "网站上的分类和排序是否会定期更新？",
    answer: "是的。我们的编辑团队会定期巡检已收录的网站，确保链接有效、信息准确。同时，我们会根据网站质量和用户反馈调整推荐排序，删除失效或质量下降的网站，确保导航目录始终保持高质量。",
  },
  {
    question: "柠檬导航的网站数据多久更新一次？",
    answer: "网站目录每周进行一次常规更新，包括新增收录、信息修正和失效链接清理。推荐排序和热门榜单每月根据实际访问数据和用户评价进行调整。如果您发现任何问题，欢迎随时通过联系我们页面反馈。",
  },
  {
    question: "如何在手机上使用柠檬导航？",
    answer: "柠檬导航采用响应式设计，完美适配手机、平板和电脑等各类设备。您可以直接在手机浏览器中访问我们的网站，系统会自动适配屏幕尺寸，提供流畅的移动端浏览体验。也可以将网站添加到手机桌面，像使用APP一样方便。",
  },
];

export const testimonials = [
  {
    name: "张明",
    role: "产品经理",
    content: "柠檬导航已经成为我每天必用的工具，分类清晰，推荐质量高，找工具再也不用到处搜索了！",
    rating: 5,
  },
  {
    name: "李婷",
    role: "UI设计师",
    content: "设计灵感分类里的网站真的太棒了，帮我打开了新世界的大门。已经推荐给整个设计团队使用。",
    rating: 5,
  },
  {
    name: "王磊",
    role: "自由开发者",
    content: "开发编程分类特别全，从文档到工具到社区都有，是我日常开发的好帮手。强烈推荐！",
    rating: 5,
  },
  {
    name: "陈芳",
    role: "自媒体运营",
    content: "资源下载分类帮我解决了找素材的大难题，免费可商用的图片网站推荐简直太实用了。",
    rating: 5,
  },
  {
    name: "刘洋",
    role: "大学生",
    content: "学习平台分类里的免费课程资源特别丰富，帮我省了好多钱。感谢柠檬导航的精心筛选！",
    rating: 5,
  },
  {
    name: "赵敏",
    role: "创业者",
    content: "办公协同工具推荐帮我选对了团队工具组合，团队协作效率明显提升了，非常感谢！",
    rating: 4,
  },
];